// @flow
import React from "react";
import _ from "lodash";
import moment from "moment";
import Print from "rc-print";
import logoEn from "../../../images/logo/noon_en.svg";
import logoAr from "../../../images/logo/noon_ar.svg";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";

const PrintInvoice = props => {
  const { picklistItems, seller, setRef } = props;

  const lang = Helper.getLang();

  const otherStyle = `
    @import url('https://fonts.googleapis.com/css?family=Cairo:200,400,700&subset=arabic,latin-ext');


             .printTable {
               width: 100%;
               font-family: ${
                 lang === "ar" ? "Cairo" : "Proxima Nova"
               }, sans-serif;
               border-collapse: collapse;
               color: #404553;
               text-align: ${lang === "ar" ? "right" : "left"};
               font-size: 12px;
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .tableHead {
               position: relative;
               font-size: 12px;
               background: #eeeeee;
               -webkit-print-color-adjust:exact;
             }
             .printTable td, .printTable th {
               padding: 10px;
               border-bottom: 1px solid #ebedee;
               direction: ${lang === "ar" ? "rtl" : "ltr"};
             }
             .printTable tr {
               direction: ${lang === "ar" ? "rtl" : "ltr"};

             }
             .noWrap {
               white-space: nowrap;
             }


               .bold {
                 font-weight: 600;
               }



               /***/

               .ctr {
                 font-family: ${
                   lang === "ar" ? "Cairo" : "Proxima Nova"
                 }, sans-serif;

                 color: #404553;
                 background: yellow;
                 padding: 10px 0;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
               }
               .header {
                 display: flex;
                 align-items: center;
                 justify-content: center;
                 background: red;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
                 border-bottom: 1px solid #eaeaea;
                 padding: 10px 0 20px;
               }
               .logoCtr {
                 height: 35px;

               }
               .logo {
                 height: 100%;
                 width: auto;
               }

               .summary {
                 border-bottom: 1px solid #eaeaea;
                 padding: 10px 0;
                 display: flex;
                 align-items: flex-start;
                 justify-content: space-between;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
               }


               .asnCtr {
                 margin-left: ${lang === "ar" ? 0 : "20px"};
                 margin-right: ${lang === "ar" ? "20px" : 0};
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
                 flex: 1;
               }

               .asnCtr:first-child {
                 margin-left: 0;
                 margin-right: 0;
               }

               .asnTitle {
                 color: #bababa;
                 font-size: 11px;
                 font-family: ${
                   lang === "ar" ? "Cairo" : "Proxima Nova"
                 }, sans-serif;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
               }
               .asnNr {
                 color: #4a4a4a;
                 font-size: 15px;
                 font-weight: 600;
                 font-family: ${
                   lang === "ar" ? "Cairo" : "Proxima Nova"
                 }, sans-serif;
                 margin: 5px 0;
               }
               .tableTitle {
                 color: #4a4a4a;
                 -webkit-print-color-adjust:exact;
                 font-size: 20px;
                 font-weight: 600;
                 padding: 10px 0;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};
                 font-family: ${
                   lang === "ar" ? "Cairo" : "Proxima Nova"
                 }, sans-serif;
                 margin: 5px 0;
               }
               .eachTable {
                 margin: 10px 0 40px;
               }
               .flexFix {
                 flex: 1;
               }
               .center {
                 text-align: center;
               }
               .attributes {
                 font-size: 12px;
                 color: #93939a;
                 font-weight: unset;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};

               }
               .eachAttr {
                 margin-right: ${lang === "ar" ? "0" : "10px"};
                 margin-right: ${lang === "en" ? "10px" : "0"};
                 // white-space: nowrap;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};

               }

               a {
                 color: #404553;
                 font-weight: 600;
                 direction: ${lang === "ar" ? "rtl" : "ltr"};

               }

       `;

  const productBox = item => (
    <div>
      {item.title}
      <div className="attributes">
        <span className="eachAttr bold">
          <a>{item.brand}</a>
        </span>
        <span>
          {item.variant ? (
            <span className="eachAttr">
              {I18n.getHtml("order-details.variant", {
                variant: item.variant
              })}
            </span>
          ) : (
            ""
          )}
        </span>
        <span>
          {item.model ? (
            <span className="eachAttr">
              {I18n.getHtml("order-details.model", {
                model: item.model
              })}
            </span>
          ) : (
            ""
          )}
        </span>
        {item.attributes && !_.isEmpty(JSON.parse(item.attributes)) ? (
          <span className="eachAttr">
            {JSON.parse(item.attributes).colour_family ? (
              <span>
                {I18n.getHtml("order-details.color", {
                  color: JSON.parse(item.attributes).colour_family
                })}
              </span>
            ) : (
              ""
            )}
          </span>
        ) : (
          ""
        )}
      </div>
    </div>
  );

  const eachTab = (list, property) => (
    <div className="eachTable">
      <table className="printTable">
        <thead>
          <tr className="tableHead">
            {property.haveVal("title") ? (
              <th>{I18n.getText("product-table.name")}</th>
            ) : (
              ""
            )}
            {property.haveVal("sku") ? (
              <th>{I18n.getText("product-table.sku")}</th>
            ) : (
              ""
            )}
            {property.haveVal("partner_sku_unique") ? (
              <th>{I18n.getText("offer.p-sku-unique")}</th>
            ) : (
              ""
            )}
            {property.haveQtyVal("qty") ? <th>{I18n.getText("variants.qty")}</th> : ""}
          </tr>
        </thead>
        <tbody>{list}</tbody>
      </table>
    </div>
  );

  const la = (data, property) =>
    data && !_.isEmpty(data)
      ? data.map((item, index) => (
          <tr>
            {property.haveName ? <td>{productBox(item)}</td> : ""}

            {property.haveSku ? <td className="noWrap">{item.sku}</td> : ""}
            {property.havePSkuUnique ? (
              <td className="noWrap">{item.partner_sku_unique}</td>
            ) : (
              ""
            )}
            {property.haveQty ? <td className="noWrap">{item.qty}</td> : ""}
          </tr>
        ))
      : "";

  const property = Helper.validator(picklistItems);

  return (
    <div>
      <Print
        ref={setRef}
        insertHead={false}
        ignoreHeadJs={false}
        title={lang === "ar" ? "عمليات النقل" : "Transfers"}
        otherStyle={otherStyle}
      >
        <div style={{ display: "none" }} className="ctr">
          <div className="header">
            <div className="logoCtr">
              <img
                src={lang === "ar" ? logoAr : logoEn}
                alt="logo"
                className="logo"
              />
            </div>
          </div>
          <div className="summary">
            {seller ? (
              <div className="asnCtr">
                <h4 className="asnTitle">
                  {I18n.getText("print.partner-name")}
                </h4>
                <div className="asnNr">{seller.storeName}</div>
              </div>
            ) : (
              ""
            )}
            <div className="asnCtr">
              <h4 className="asnTitle">
                {I18n.getText("stock-request.picklist-nr")}
              </h4>
              <div className="asnNr">
                {picklistItems &&
                  !_.isEmpty(picklistItems) &&
                  picklistItems[0].picklist_nr}
              </div>
            </div>
          </div>

          <div className="tableCtr">
            {eachTab(la(picklistItems, property), property)}
          </div>
        </div>
      </Print>
    </div>
  );
};

export default PrintInvoice;



// WEBPACK FOOTER //
// ./src/components/stockRequest/print/Print.js